import { createSignal } from '@funtech-int/rival';

export const promoContentIdVar = createSignal<string | null>(null);
